import type { ReactElement } from "react";
import { Navigate } from "react-router-dom";

export const SessionInformationRedirect = (): ReactElement => <Navigate replace to="/resources/" />;

export const NewbornSessionRedirect = (): ReactElement => (
  <Navigate replace to="/resources/newborn/how-to-prepare-for-your-newborn-session/" />
);

export const FamilySessionRedirect = (): ReactElement => (
  <Navigate replace to="/resources/family/how-to-prepare-for-your-family-photo-session/" />
);

export const NewbornAnxietyArticleRedirect = (): ReactElement => (
  <Navigate replace to="/resources/newborn/how-to-prepare-for-your-newborn-session/" />
);

export const BabyDoesNotSleepArticleRedirect = (): ReactElement => (
  <Navigate replace to="/resources/newborn/what-happens-during-a-newborn-session/" />
);

export const ChristeningPricingRedirect = (): ReactElement => <Navigate replace to="/prices/maternity/" />;
